module.exports = __webpack_public_path__ + "img/thumbnail_BengalTiger_j_normal.421096b8.png";